module.exports = __webpack_public_path__ + "images/category_lp/hobby/store_images/1@2x_23489f42fed425f1201a27667b1c6554.png";